import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Tag,
  Dropdown,
  Menu,
  Pagination,
  Space,
  Card,
  Row,
  Select,
  Modal,
  Form,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  DownOutlined,
  SearchOutlined,
  PrinterOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import DownloadTableButtons from "../../../../components/layouts/enhancement/DownloadTableButtons";
import styles from "../../../../assets/styles/styles";
import RightSidebar from "../../../../components/layouts/RightSidebar";
import { labelConfig, staticConfig } from "../../operations.config";
import { connect, useDispatch } from "react-redux";
import { rightAction } from "../../../../redux/actions";
import { BOM } from "../../../../services/definedMethod";
import "../../../../assets/styles/InterbankPlacement.css";

const data = Array.from({ length: 18 }).map((_, index) => ({
  key: index,
  dealRef: "20250323234500020",
  counterparties: ["Access Bank", "EcoBank", "FirstBank", "+4"],
  rate: "12 %",
  tenor: "10 days",
  amount: "100,000,000,000.00",
  status: index % 2 === 0 ? "Active" : "Closed",
}));

const InterbankPlacement = (props) => {
  const pageSize = 10; //number of items per page
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);
  const { userData, rightBtn, rightAction } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [tableStatus, setTableStatus] = useState("Status");
  const [tableCount, setTableCount] = useState("10");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);

  // select Fiilter action
  const filteredData =
    tableStatus === "Status"
      ? data
      : data.filter((item) => item.status === tableStatus);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  const totalPages = Math.ceil(filteredData.length / pageSize);

  const columns = [
    {
      title: "Deal Reference",
      dataIndex: "dealRef",
    },
    {
      title: "CounterParty",
      dataIndex: "counterparties",
      render: (counterparties) => (
        <Space>
          {counterparties.map((party, i) => (
            <Tag
              key={i}
              style={{
                borderRadius: "20px",
                backgroundColor: "#FDF4FF",
                borderColor: "#F6D0FE",
                color: "#9F1AB1",
              }}
            >
              {party}
            </Tag>
          ))}
        </Space>
      ),
    },
    {
      title: "Propose Rate",
      dataIndex: "rate",
    },
    {
      title: "Deal Tenor",
      dataIndex: "tenor",
    },
    {
      title: "Deal Amount",
      dataIndex: "amount",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        if (status === "Active") {
          return (
            <Tag
              style={{
                borderRadius: "20px",
                borderColor: "#ABEFC6",
                color: "#067647",
                backgroundColor: "#ECFDF3",
              }}
            >
              {status}
            </Tag>
          );
        } else {
          return (
            <Tag
              style={{
                borderRadius: "20px",
                borderColor: "#ABEFC6",
                color: "#EAECF0",
                backgroundColor: "#F9FAFB",
                color: "#344054",
              }}
            >
              {status}
            </Tag>
          );
        }
      },
    },
  ];

  useEffect(() => {
    BOM.HasPermission("CREATE_CLIENT") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  //DECLARED METHODS
  const onSelectItemAction = (selectedKeys, selectedRows) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRowKeys(selectedKeys);
    setSelectedRow(selectedRows);

    if (selectedKeys.length === 1) {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      [cnt.RIGHT_DETAIL_BTN].map((item) => {
        dispatch({ type: item });
      });
      // will be changes when endpoint is give
      dispatch({ type: cnt.RIGHT_EDIT_BTN });
    } else if (selectedKeys.length > 1) {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      dispatch({ type: cnt.RIGHT_DELETE_BTN });
    } else {
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });
      dispatch({ type: cnt.RIGHT_ADD_BTN });
    }
  };

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      setModalVisible(true);

      // navigate("/new-operations-interbank-placement", { state:selectedRow  });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-operations-interbank-placement", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/new-operations-interbank-placement", { state:selectedRow  });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleContinue = (values) => {
    console.log("Form values:", values);
    setModalVisible(false);
    // Handle form submission here
  };

  // PAINATION ARROE DISABLING
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onAdd={handleOnCreate}
      onView={handleOnView}
      onEdit={handleOnEdit}
      pageItems={staticConfig.moneyMarketInterbankPlacementBreadcrumbItems}
    >
      <CreateModal
        visible={modalVisible}
        onCancel={handleCancel}
        onContinue={handleContinue}
        selectedRow={selectedRow}
      />
      <TopContent
        pageTitle={labelConfig.manageMoneyMarketInterbankPlacement}
        createPageTitle={labelConfig.manageMoneyMarketInterbankPlacement}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
          marginTop: 20,
        }}
      >
        {/* Top Bar */}
        <Row style={{ marginBottom: 20 }}>
          <div style={{ margin: "0px 5px" }}>
            <Input
              placeholder="Search by deal deference ID..."
              style={{
                width: 320,
                borderColor: "#D0D5DD",
                borderRadius: 8,
                height: 36,
              }}
              prefix={<SearchOutlined />}
            />
          </div>
          <div
            style={{ marginBottom: "auto", marginLeft: 10 }}
            className="interbank-table-select"
          >
            <Select
              value={tableStatus}
              onChange={(value) => {
                setTableStatus(value);
                setCurrentPage(1); // Reset to page 1 on filter change
              }}
              options={[
                { value: "Status", label: "Status" },
                { value: "Active", label: "Active" },
                { value: "Closed", label: "Closed" },
              ]}
            />
          </div>

          <div
            style={{
              marginLeft: "auto",
            }}
          >
            <Space>
              <Button type="default">Export CSV</Button>
              <Button icon={<PrinterOutlined />}>Print</Button>
            </Space>
          </div>
        </Row>

        {/* Table */}
        <div className="interbankplacement-table">
          <Table
            // bordered
            columns={columns}
            dataSource={paginatedData}
            pagination={false}
            rowKey="key"
            rowSelection={{
              selectedRowKeys,
              onChange: onSelectItemAction,
            }}
          />
        </div>

        {/* Pagination */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <div
            className="interbankplacement-table-pagination"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <ArrowLeftOutlined />
              Previous
            </Button>

            <Pagination
              current={currentPage}
              total={filteredData.length}
              pageSize={pageSize}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
              itemRender={itemRender}
              // hideOnSinglePage={true}  // This hides the pagination when there's only one page
            />

            <Button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage >= totalPages}
            >
              Next
              <ArrowRightOutlined />
            </Button>
          </div>
        </div>
      </Card>
    </MainLayout>
  );
};

// MODAL
const CreateModal = ({ visible, onCancel, onContinue, selectedRow }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const handleContinue = () => {
    form
      .validateFields()
      .then((values) => {
        onContinue(values);
        form.resetFields();
        navigate("/new-operations-interbank-placement", { state: selectedRow });
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <Modal
      title="Create MM Deal"
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      closeIcon={<span style={{ fontSize: "18px" }}>×</span>}
      className="interbankplacement-modal"
    >
      <p style={{ marginBottom: "24px", fontSize: "14px" }}>
        Select the category and type you want to apply the deal
      </p>

      <Form form={form} layout="vertical">
        <Form.Item
          label={
            <span>
              Product Category&nbsp;
              <Tooltip title="Select a product category">
                <InfoCircleOutlined style={{ color: "rgba(0, 0, 0, 0.45)" }} />
              </Tooltip>
            </span>
          }
          name="productCategory"
          // rules={[{ required: true, message: "Please select product category" }]}
        >
          <Select
            placeholder="Select product category"
            style={{ width: "100%", height: "44px" }}
          >
            <Select.Option value="dept_instrument">
              Dept Instrument
            </Select.Option>
            <Select.Option value="investment">Investment</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span>
              Product Type&nbsp;
              <Tooltip title="Select a product type">
                <InfoCircleOutlined style={{ color: "rgba(0, 0, 0, 0.45)" }} />
              </Tooltip>
            </span>
          }
          name="productType"
          // rules={[{ required: , message: "Please select product type" }]}
        >
          <Select
            placeholder="Select product type"
            style={{ width: "100%", height: "44px" }}
          >
            <Select.Option value="Interbank Placement">
              Interbank Placement
            </Select.Option>
            <Select.Option value="Call Deposite">Call Deposit</Select.Option>
            <Select.Option value="Fixed Deposit">Fixed Deposit</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item style={{ marginTop: "24px" }}>
          <Button
            type="primary"
            onClick={handleContinue}
            block
            style={{
              backgroundColor: "#BA24D5",
              borderColor: "#BA24D5",
              height: "40px",
            }}
          >
            Continue
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(InterbankPlacement);
